module.exports = __webpack_public_path__ + "static/img/login-left.73ed3f93.png";